import React, { useEffect } from 'react';

export default function Logout() {
  useEffect(() => {
    let redirected = false;

    async function doLogout() {
      try {
        // Hit backend logout endpoint (server has context-path /api)
        await fetch('/api/logout', {
          method: 'GET',
          credentials: 'include'
        });
      } catch (e) {
        // ignore errors; we will redirect anyway
      } finally {
        if (!redirected) {
          redirected = true;
          window.location.replace('/');
        }
      }
    }

    // Safety timeout in case network hangs
    const t = setTimeout(() => {
      if (!redirected) {
        redirected = true;
        window.location.replace('/');
      }
    }, 2000);

    doLogout();
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{ maxWidth: 800, margin: '40px auto', textAlign: 'center' }}>
      Atsijungiama...
    </div>
  );
}
